/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result for the search of the account
 * @export
 * @interface AccountSearchResult
 */
export interface AccountSearchResult {
    /**
     * 
     * @type {string}
     * @memberof AccountSearchResult
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountSearchResult
     */
    accountName?: string;
}

/**
 * Check if a given object implements the AccountSearchResult interface.
 */
export function instanceOfAccountSearchResult(value: object): value is AccountSearchResult {
    return true;
}

export function AccountSearchResultFromJSON(json: any): AccountSearchResult {
    return AccountSearchResultFromJSONTyped(json, false);
}

export function AccountSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
        'accountName': json['accountName'] == null ? undefined : json['accountName'],
    };
}

export function AccountSearchResultToJSON(json: any): AccountSearchResult {
    return AccountSearchResultToJSONTyped(json, false);
}

export function AccountSearchResultToJSONTyped(value?: AccountSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountNumber': value['accountNumber'],
        'accountName': value['accountName'],
    };
}

